// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fQ3y","questions":"styles_questions__u1xtf","footer":"styles_footer__CM93x"};